import { InputHTMLAttributes, forwardRef, ForwardedRef } from 'react';

import { BaseInput } from '@hh.ru/magritte-ui-input/BaseInput';
import { ControlledInputProps } from '@hh.ru/magritte-ui-input/types';

// Здесь создаем новый компонент, а не переиспользуем BaseInput as <...>, чтобы обеспечить уникальность displayName
const InputComponent = (
    props: ControlledInputProps & Omit<InputHTMLAttributes<HTMLInputElement>, keyof ControlledInputProps>,
    ref: ForwardedRef<HTMLInputElement>
) => <BaseInput ref={ref} {...props} />;

const Input = forwardRef(InputComponent);

Input.displayName = 'Input';

export { Input };
